import { FeedbackOptionsModel, FeedbackProblemOptionsDto } from '../types/help-center-feedback'

export const transformFeedbackProblemOptions = (
  options: Array<FeedbackProblemOptionsDto>,
): Array<FeedbackOptionsModel> =>
  options.map(option => {
    const { id, body, allow_user_input } = option

    return {
      id,
      body,
      hasMessageInput: allow_user_input,
    }
  })
